
export default {
    props: ['buttonOrange', 'buttonPink', 'campusText', 'campusLogoHeader', 'buttonLinkHeaderTwo',
        'collone1Diplomas', 'collone2Diplomas', 'collone3Diplomas', 'nomCollone1', 'nomCollone2',
        'nomCollone3', 'global', 'campusLogoHeaderDiplomaValidation', 'rootLevel'],

    data() {
        return {
            showList: false,
            openNavBar: false,
        }
    },

    methods: {
        openDiplomasList(event) {
            this.showList = !this.showList;
        },
        close(e) {
            if (!this.$el.contains(e.target)) {
                this.showList = false
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.close)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.close)
    }

}


